import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { BitfApiService } from '@bitf/services/api/bitf-api.service';

import { environment } from '@env/environment';

import { StoreService } from '../store.service';
import { IBitfApiResponse, IBitfApiRequest } from '@interfaces';
import { BitfFormItemConfig } from '@models';
import { EBitfInterceptors } from '@enums';

@Injectable({
  providedIn: 'root',
})
export class FullSearchService extends BitfApiService {
  constructor(public injector: Injector) {
    super('spsearch', injector);
  }
}
